
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum/[countryCode]/[grade]",
      function () {
        return require("private-next-pages/curriculum/[countryCode]/[grade]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum/[countryCode]/[grade]"])
      });
    }
  